// @ts-nocheck
import { capitalize } from 'lodash';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Selector, SelectorOptionPropsInterface } from 'sonata-react-components';

import { reportingInsightsSetGroupByConfig } from '@/store/actions/reporting.actions';
import { getSelectedCampaigns } from '@/store/selectors/reporting.selectors';
import { getCampaigns } from '@/store/selectors/reportingAdvancedFilter.selectors';

import './dcoDimensionSelector.scss';

type Props = {
  insightId: string;
  label: string;
  onFilter: (optionSelected: { value: string }) => void;
};
const DIMENSIONS = ['context', 'scenario'];

const DcoDimensionSelector: React.VFC<Props> = ({ insightId, label, onFilter }) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const campaignIds: string[] = useSelector(getCampaigns);
  const reportingCampaigns: Record<string, any>[] = useSelector(getSelectedCampaigns);
  const campaigns = reportingCampaigns.filter(({ id }) => campaignIds.includes(id));

  const options: SelectorOptionPropsInterface[] = DIMENSIONS.filter(
    dimenssion => campaigns.length > 1 || dimenssion !== DIMENSIONS[0]
  ).map(dimension => ({
    id: dimension,
    label: formatMessage({
      defaultMessage: capitalize(dimension),
      id: `reporting.insights.filters.selectors.dco.options.${dimension}`
    }),
    value: dimension
  }));

  const defaultValue = options[0];

  useEffect(() => {
    onFilter(defaultValue);
  }, []);

  const handleChange = (option: SelectorOptionPropsInterface): void => {
    onFilter(option);
    dispatch(
      reportingInsightsSetGroupByConfig({
        insightGroupByConfig: { groupBy: option },
        insightId
      })
    );
  };

  return (
    <div className="dcoDimension">
      <Selector
        className="dcoDimension__selector"
        defaultValue={[defaultValue]}
        label={label}
        onChange={handleChange as (option: SelectorOptionPropsInterface) => void}
        options={options}
        type="simple"
      />
    </div>
  );
};

export default DcoDimensionSelector;
